// extracted by mini-css-extract-plugin
export var downArrow = "_ac-0";
export var infoTooltipIcon = "_ac-3";
export var label = "_ac-1";
export var optionCard = "_ac-4";
export var upArrow = "_ac-2";